import * as React from "react";
import { TRANSLATIONS_API } from "src/config";
import { Loader } from "src/common/components";

interface IWithLocales {
  locales: string[];
}

export const LocalesContext = React.createContext<IWithLocales>({
  locales: []
});

interface IProviderProps {
  children: React.ReactNode;
}

export const LocalesProvider = ({ children }: IProviderProps) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [locales, setLocales] = React.useState<string[]>([]);

  React.useEffect(() => {
    fetch(TRANSLATIONS_API)
      .then(response => response.json())
      .then(data => {
        setLocales(data.locales);
      })
      .catch(error => {
        console.error("Error:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return <LocalesContext.Provider value={{ locales }}>{children}</LocalesContext.Provider>;
};
